import { Button, Container, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Page from '../components/Page';
import Iconify from '../components/Iconify';
import { PATH_DASHBOARD } from '../routes/paths';

export default function Unauthorized() {
  return (
    <Page title="Unauthorized">
      <Container maxWidth="md" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
        <Stack spacing={3} alignItems="center" textAlign="center" sx={{ width: 1 }}>
          <Iconify icon="solar:lock-keyhole-minimalistic-bold" sx={{ width: 72, height: 72, color: 'warning.main' }} />
          <Typography variant="h3">Access Restricted</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 560 }}>
            This admin route is governed by backend access control. Your current session does not have permission to open
            this screen or action.
          </Typography>
          <Button component={RouterLink} to={PATH_DASHBOARD.dashboard.root} variant="contained">
            Return to Dashboard
          </Button>
        </Stack>
      </Container>
    </Page>
  );
}
